import { render, staticRenderFns } from "./Faculty.vue?vue&type=template&id=fd38314c&scoped=true&"
import script from "./Faculty.vue?vue&type=script&lang=js&"
export * from "./Faculty.vue?vue&type=script&lang=js&"
import style0 from "./Faculty.vue?vue&type=style&index=0&id=fd38314c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd38314c",
  null
  
)

export default component.exports